
export default function objectFitPolyfill() {
    // eslint-disable-next-line
    if(!Modernizr.objectfit) {
        const images = document.querySelectorAll('.h-placeholder-image, .h-video-play');

        for (let x = 0; x < images.length; x++) {
            var image = images[x].querySelector('img');

            if(image != null && !images[x].classList.contains('h-compat-object-fit')) {
                var lazyImgUrl = image.getAttribute('data-lazy-img-loading');
                var imgUrl = image.getAttribute('src');

                images[x].classList.add('h-compat-object-fit');

                if(lazyImgUrl) {
                    images[x].style.backgroundImage = 'url(' + lazyImgUrl + ')';
                } else {
                    images[x].style.backgroundImage = 'url(' + imgUrl + ')';
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/object-fit.js